import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import {registerLocale, setDefaultLocale} from 'react-datepicker';
import slLocale from 'date-fns/locale/sl';
import roLocale from 'date-fns/locale/ro';
import bgLocale from 'date-fns/locale/bg';
import enLocale from 'date-fns/locale/en-GB';

import en from './@i18n/en.json';
import sl from './@i18n/sl.json';
import bg from './@i18n/bg.json';
import ro from './@i18n/ro.json';

// Register date-fns locales for react-datepicker
registerLocale('sl', slLocale);
registerLocale('ro', roLocale);
registerLocale('bg', bgLocale);
registerLocale('en', enLocale);

i18n.use(initReactI18next).init({
  resources: {
    en: {translation: en.main},
    sl: {translation: sl.main},
    bg: {translation: bg.main},
    ro: {translation: ro.main},
  },
  // lng: 'en', // default language
  lng: process.env.REACT_APP_LANG, // default language
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
});

// Set datepicker default locale to match i18n language
setDefaultLocale(i18n.language);

// Update datepicker locale when i18n language changes
i18n.on('languageChanged', (lng) => {
  setDefaultLocale(lng);
});

export default i18n;
